import React from 'react';
import { connect } from 'react-redux';
import { NLink, NText, Tooltip } from '@fttb/common';
import PropTypes from 'prop-types';
import { useEffectOnlyOnce } from "../../../../hooks/useEffectOnlyOnce";
import { onAnchorClickSlideToTariff } from "../../../../store/blocks/checkAddress/actions";
import { runCheckAddressResult } from "../../../../store/checkAddress/actions";
var _MapTooltip = function _MapTooltip(_ref) {
  var actionHref = _ref.actionHref,
    actionText = _ref.actionText,
    children = _ref.children,
    className = _ref.className,
    isError = _ref.isError,
    onClick = _ref.onClick,
    onRender = _ref.onRender;
  // TODO: исправить onRender, данный аргумент должен быть boolean типа
  useEffectOnlyOnce(onRender, [onRender], function (dependencies) {
    return !!dependencies[0];
  });
  return /*#__PURE__*/React.createElement(Tooltip, {
    className: className,
    isError: isError,
    "data-t-id": "components-MapTooltip"
  }, /*#__PURE__*/React.createElement(NText, {
    className: "mar-b-xs",
    color: "inherit",
    size: "size7-r",
    "data-t-id": "components-MapTooltip"
  }, children), actionText && /*#__PURE__*/React.createElement(NText, {
    color: "inherit",
    size: "size7-m"
  }, /*#__PURE__*/React.createElement(NLink, {
    extraAttributes: {
      style: {
        color: '#fff'
      }
    },
    href: actionHref,
    onClick: onClick,
    "data-t-id": "components-MapTooltip"
  }, actionText)));
};
_MapTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  actionHref: PropTypes.string,
  actionText: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  isError: PropTypes.bool,
  onClick: PropTypes.func,
  onRender: PropTypes.func
} : {};
var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var actionHref = _ref2.actionHref,
    addressData = _ref2.addressData,
    children = _ref2.children;
  return {
    onClick: function onClick(event) {
      if (actionHref.includes('#')) {
        event.preventDefault();
        dispatch(onAnchorClickSlideToTariff());
      }
    },
    onRender: function onRender() {
      return dispatch(runCheckAddressResult(children, addressData));
    }
  };
};
export var MapTooltip = connect(null, mapDispatchToProps)(_MapTooltip);